/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ago_Zippy_Mammoth_HeartInputs */

const fr_ago_zippy_mammoth_heart = /** @type {(inputs: Ago_Zippy_Mammoth_HeartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine des programmes`)
};

/**

* @param {Ago_Zippy_Mammoth_HeartInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const ago_zippy_mammoth_heart = /** @type {((inputs?: Ago_Zippy_Mammoth_HeartInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ago_Zippy_Mammoth_HeartInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_ago_zippy_mammoth_heart(inputs)
});